import React, { useEffect, useState } from "react";
import { Container } from "semantic-ui-react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import DataProvider from "../data/DataProvider";
import DataConsumer from "../data/DataConsumer";
import { getResourceConfig } from "../reducers/app-config";
import { setFilter } from "../reducers/data";
import Gallery from "./Gallery";
import Filters from "./Filters";
const Resources = props => {
  const {
    "data-country": country = "BFA",
    "data-page-columns": pageColumns = 3,
    "data-page-size": pageSize = 9,
    "data-read-more-text": readMoreText = "Read More",
    "data-no-data-message": noDataMessage = "No data available",
    "data-api-url": apiURL,
    categories,
    categoryIdsFilter,
    editing,
    getResourceConfig,
    intl: {
      locale
    },
    setFilter,
    subjectIdsFilter,
    subjects,
    themeIdsFilter,
    themes
  } = props;
  const [page, setPage] = useState(0);
  const app = "admin";
  const source = `${decodeURIComponent(apiURL)}/country/resource?lang=${locale}&page=${page}&pageSize=${pageSize}`;
  const type = "post";
  useEffect(() => {
    getResourceConfig(country);
  }, [getResourceConfig, country]);
  return /*#__PURE__*/React.createElement(Container, {
    className: `wp-react-lib ${editing ? "editing" : ""}`,
    fluid: true
  }, /*#__PURE__*/React.createElement(Filters, {
    categories: categories || [],
    categoryIdsFilter: categoryIdsFilter || [],
    subjectIdsFilter: subjectIdsFilter || [],
    subjects: subjects || [],
    themeIdsFilter: themeIdsFilter || [],
    themes: themes || [],
    setFilter: setFilter
  }), /*#__PURE__*/React.createElement(DataProvider, {
    app: app,
    source: source,
    type: type,
    params: {
      iso3: country,
      categoryIds: categoryIdsFilter || []
    },
    store: [app, props.unique, ...source.split("/")]
  }, /*#__PURE__*/React.createElement(DataConsumer, null, /*#__PURE__*/React.createElement(Gallery, {
    categories: categories || [],
    page: page,
    pageColumns: pageColumns,
    readMoreText: readMoreText,
    noDataMessage: noDataMessage,
    setPage: setPage
  }))));
};
const mapStateToProps = (state, ownProps) => ({
  categories: state.getIn(["app-config", "countries", ownProps["data-country"], "resourceConfig", "categories"]),
  categoryIdsFilter: state.getIn(["data", "filters", "categoryIds"]),
  subjectIdsFilter: state.getIn(["data", "filters", "subjectIds"]),
  subjects: state.getIn(["app-config", "countries", ownProps["data-country"], "resourceConfig", "subjects"]),
  themeIdsFilter: state.getIn(["data", "filters", "themeIds"]),
  themes: state.getIn(["app-config", "countries", ownProps["data-country"], "resourceConfig", "themes"])
});
const mapActionCreators = {
  getResourceConfig,
  setFilter
};
export default connect(mapStateToProps, mapActionCreators)(injectIntl(Resources));